module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48c3ZnIGlkPSJMYXllcl8yIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMy43MyAyMS4xMyI+PGcgaWQ9IkxheWVyXzEtMiI+PHBhdGggZD0iTTIuNzMsMEwwLDE3LjI5bDQuNDgtMi43MywxLjc2LDYuNTgsNC0xLjA3LTEuNzYtNi41OCw1LjI1LC4xM0wyLjczLDBaIi8+PC9nPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/Asset 4.svg
// module id = udJp
// module chunks = 1